import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";

const UniversitySemesterEdit = () => {
  const [semester, setSemester] = useState("");
  const { id } = useParams();
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/semesters/${id}`)
      .then((response) => {
        const semesterData = response.data?.data;
        if (semesterData) {
          setSemester(semesterData.semesterName);
        }
      })
      .catch((error) => console.log(error));
  }, [API_BASE_URL, id]);

  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .put(`${API_BASE_URL}/semesters/${id}`, { semesterName: semester })
      .then(() => {
        alert("Semester updated successfully!");
        navigate("/college-semester-table");
      })
      .catch((error) => console.log(error));
  };

  return (
    <div id="add-college-course-wrapper">
      <div className="course-header-with-btns">
        <h5>Semester/Year</h5>
        <div className="college-course-nav-btns">
          <Link to={"/college-semester"}>
            <button className="college-add-course-add-btn">
              + Add New Semester/Year
            </button>
          </Link>
          <Link to={"/college-semester-table"}>
            <button className="college-all-course-btn">
              All Semesters/Year
            </button>
          </Link>
        </div>
      </div>

      <div className="add-college-course-inner-main-wrapper">
        <div className="form-main-container">
          <h4 className="college-course-detail">Edit Semester/Year</h4>
          <form onSubmit={handleSubmit} className="college-course-detail-form">
            <div className="input-group">
              <label className="label">Enter Semester</label>
              <input
                style={{
                  marginLeft: "1px",
                  borderBottomLeftRadius: "5px",
                  borderTopLeftRadius: "5px",
                }}
                type="text"
                value={semester}
                onChange={(e) => setSemester(e.target.value)}
                placeholder="Enter Semester..."
                required
              />
            </div>

            <div className="college-course-form-btns">
              <button className="btn-search" type="submit">
                Save
              </button>
              <button
                className="btn-cancel"
                type="button"
                onClick={() => navigate("/college-semester-table")}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default UniversitySemesterEdit;
